import { Color, DefaultValue, FontSize, FontWeight, LineHeight, Spacing } from '@billy/design-system'
import { transparentize } from 'polished'

import { FORMS_INNER_SHADOW } from '../constants/formsInnerShadow'
import colors from './colors'

const BORDER_RADIUS = DefaultValue.BorderRadius
const MARGIN_BOTTOM = 10
const HEIGHT = 40
const HEIGHT_BIG = 48

const DISABLED = {
  color: Color.Grey200,
  borderColor: Color.Grey200,
  backgroundColor: Color.Grey100,
  boxShadow: 'none',

  '&::placeholder': {
    color: Color.Grey200,
  },
}

const FOCUS = {
  '&:focus, &.focus': {
    borderColor: Color.Green400,
    boxShadow: `${FORMS_INNER_SHADOW}, 0 0 0 3px ${Color.Green100}`,
  },
}

const SELECT = {
  boxShadow: `${FORMS_INNER_SHADOW}, 0 1px 2px ${transparentize(0.3, Color.Grey200)}`,
  fontWeight: FontWeight.Medium,

  '&::placeholder': {
    opacity: 1,
    color: Color.Black,
    fontSize: FontSize.TextBodyMD,
    fontWeight: FontWeight.Medium,
  },
  '&:disabled': {
    '&::placeholder': {
      color: Color.Grey300,
    },
  },
  '&:not(:disabled):not(.invalid)': {
    ...FOCUS,
  },
}

const errorStyle = {
  backgroundColor: Color.Red50,
  borderColor: Color.Red700,

  '&, &.for-select': {
    '&:focus, &.focus': {
      borderColor: Color.Red700,
      boxShadow: `${FORMS_INNER_SHADOW}, 0 0 0 3px ${transparentize(0.8, Color.Red300)}`,
    },
    '&:hover': {
      borderColor: Color.Red700,
    },
  },
}

const inputStyle = {
  outline: 'none',
  padding: `${Spacing.S8} ${Spacing.S12}`,
  width: '100%',
  fontFamily: DefaultValue.FontFamily,
  fontSize: FontSize.TextBodyMD,
  color: Color.Black,
  border: `1px solid ${Color.Grey200}`,
  borderRadius: BORDER_RADIUS,
  backgroundColor: Color.White,
  boxShadow: FORMS_INNER_SHADOW,
  transition: `
    border ${DefaultValue.TransitionDuration} ${DefaultValue.TransitionTimingFunction},
    background ${DefaultValue.TransitionDuration} ${DefaultValue.TransitionTimingFunction},
    box-shadow ${DefaultValue.TransitionDuration} ${DefaultValue.TransitionTimingFunction}
  `,

  '&.big': {
    padding: Spacing.S12,
  },
  '&:not(:disabled):not(.invalid):not(:focus):not(.focus):hover': {
    borderColor: Color.Black,
  },
  ...FOCUS,
  '&.invalid': errorStyle,
  '&:disabled': {
    ...DISABLED,
  },
  '&.hidden': {
    display: 'none',
  },
  '&::placeholder': {
    color: Color.Grey300,
    fontSize: FontSize.TextBodyMD,
    fontWeight: FontWeight.Regular,
  },
  '&.for-select': {
    paddingRight: '30px',
    textOverflow: 'ellipsis',
    ...SELECT,
  },
  '&.with-right-icon': {
    paddingRight: '50px',
  },
  '&.suggestion': {
    paddingRight: '90px',
  },
  '&.prefilled': {
    backgroundColor: Color.Lavender50,
    borderColor: Color.Lavender100,
    borderStyle: 'solid',
  },
}

export default {
  defaultRadius: BORDER_RADIUS,
  form: {
    margin: 0,
    '> *': {
      transition: 'background-color .1s linear, border-color .1s linear',
    },
  },
  formcontrol: {
    marginBottom: MARGIN_BOTTOM,
  },
  fieldset: {
    marginBottom: MARGIN_BOTTOM,
    padding: 0,
  },
  error: {
    '&:not:empty': {
      marginBottom: MARGIN_BOTTOM,
    },
  },
  label: {
    marginBottom: Spacing.S2,
    color: Color.Grey500,
    fontSize: FontSize.TextBodyMD,
    fontWeight: FontWeight.Regular,
    lineHeight: LineHeight.TextBodyMD,
  },
  input: {
    ...inputStyle,
    height: HEIGHT,

    '&.big': {
      height: HEIGHT_BIG,
    },
  },
  textarea: {
    ...inputStyle,
    height: HEIGHT * 2,

    '&.big': {
      height: HEIGHT_BIG * 2,
    },
  },
  select: {
    ...inputStyle,
    ...SELECT,
    height: HEIGHT,
  },
  slider: {
    position: 'relative',
    width: '100%',
    margin: '50px auto',
    height: '2px',
    zIndex: 5,
    cursor: 'pointer',
    '&::-webkit-slider-thumb': {
      width: '28px',
      height: '28px',
      borderRadius: '14px',
      border: '1px solid #2fc557',
      background: 'radial-gradient(circle, rgba(47,197,87,1) 25%, rgba(255,255,255,1) 25%)',
      zIndex: 10,
      transform: 'translateY(-14px)',
      boxShadow: '0 4px 6px -1px rgba(100,100,100, .4)',
    },
    '&::-webkit-slider-runnable-track': {
      height: '2px',
      borderRadius: '2px',
      backgroundColor: colors.gray2,
    },
  },
}
